interface Feature extends GeoJSON.Feature<GeoJSON.Geometry> {
  layer: {
    source: string,
  };
}

declare var Sentry: {
  captureMessage: Function,
};

import * as mapboxgl from 'mapbox-gl';
import getTooltip from './helpers/getTooltip';
import analyticsEvent from './helpers/analyticsEvent';
import getGeoLocationFeature from './helpers/getGeoLocationFeature';

let popups = [];

export function openTooltipForFeature(map, feature) {
  const { lat, lng } = feature.properties;
  const latLng: any = { lat, lng };

  if (typeof lat === 'undefined' || typeof lng === 'undefined') {
    return;
  }

  if (Number.isNaN(parseFloat(lat)) || Number.isNaN(parseFloat(lng))) {
    Sentry.captureMessage(`lat or lng is NaN. Info: ${lat} & ${lng}`);
    return;
  }

  const popup = new mapboxgl.Popup({
    offset: 0,
    className: 'map-popup',
    anchor: 'bottom',
  })
    .setLngLat(latLng)
    .setHTML(getTooltip(feature.properties))
    .addTo(map);

  popups.push(popup);
}

export function openTooltip(map, e) {
  const features: Feature[] = map.queryRenderedFeatures(e.point);
  const locationFeature = getGeoLocationFeature(features);

  if (locationFeature && locationFeature.length) {
    const location: any = locationFeature[0];
    const { properties } = location;
    const locationName = properties !== undefined && properties.name !== undefined ?
      location.properties.name :
      '';
    analyticsEvent('Map', 'click point', locationName);
    openTooltipForFeature(map, location);
  }
}

export function closeTooltips() {
  popups.forEach((popup) => {
    popup.remove();
  });

  popups = [];
}
